import { CountryApiService } from './../../../beneficiary/childs/country_details/country.service';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { PrimaryData, TaskStep } from 'app-models';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { ToastrService } from 'ngx-toastr';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as RolesRouteMap from 'app-models';
import { AppServicesLibraryService } from 'app-services-library';
import { ApiServicesService } from 'src/app/modules/beneficiary/services/api-services.service';
import moment from 'moment';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-beneficiary-personal-details',
  templateUrl: './beneficiary-personal-details.component.html',
  styleUrls: ['./beneficiary-personal-details.component.scss']
})
export class BeneficiaryPersonalDetailsComponent implements OnInit, OnDestroy {

  @Input() primaryData: PrimaryData;
  @Input() type: string;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  beneficiaryPersonalDetails;
  requiredFields;
  userType: string;
  observableSubscription$ = new Subject();
  stepId: any;

  isEditMode: boolean = false;
  beneficiaryId: number;
  beneficiaryImmigPersonalDetails: any;
  @Output() personalDetails = new EventEmitter<any>();
  @Input() userId: number;
  showNext: boolean = false;
  showPrev: boolean = false;
  selectedDetailAbout: any;
  showUploadPassport: boolean = true;
  personalDetailsEdit: boolean = false;
  beneficiaryProfileUpdate: any;
  profileEducationUpdate: boolean = true;
  profileUpdate: boolean = true;
  editClicked: boolean = false;

  constructor(
    private store: Store<any>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private toastr: ToastrService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    public router: Router,
    private appServicesLibraryService: AppServicesLibraryService,
  ) {

    this.disabledControls = false;
    this.typeOfButton = null;
    this.requiredFields = {};
    this.beneficiaryId = parseInt(sessionStorage.getItem('beneficiaryId'));
    this.showNext = this.dynamicDialogConfig.data?.showNext; 
    this.showPrev = this.dynamicDialogConfig.data?.showPrev;
  }

  ngOnInit(): void {
    this.stepId = this.dynamicDialogConfig.data.stepId;
    this.userType = sessionStorage.getItem('userTypeRole');
    localStorage.setItem("currentUserSelection", JSON.stringify(this.selectedDetailAbout));
    this.selectedDetailAbout = {
      showDetailFor: 'self',
    };
    this.personalDetailsEdit = (this.beneficiaryProfileUpdate == 'true');
    this.getBeneDetailsLibrary();
    this.store.pipe(select(getStepStatusUpdate))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
        }
      });
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.stepId }))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: TaskStep) => {
        if (data && data.id) {
          this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
          this.stepDetails = data;
          this.toggleControlsStatus();
        }
      });
  }

 


  setBeneficiaryPersonalDetails(response: ImagilityBaseResponse) {
    this.beneficiaryPersonalDetails = response.data ? {
      ...response.data,
    } : null;
  }

  onHasPassportChange(flag: boolean) {
    this.showUploadPassport = flag;
  }

  personalDetail(param) {
    this.getBeneDetailsLibrary();
}


onEditClicked(status) {
  this.editClicked = status;
}


getBeneDetailsLibrary() {
  if (this.beneficiaryProfileUpdate === 'true' || (sessionStorage.getItem('listBeneficiaryId') && sessionStorage.getItem('relativeId'))) {   //beneficiaryId
    this.profileEducationUpdate = false;
    this.profileUpdate = true;
  } else {
    this.profileEducationUpdate = true;
    this.profileUpdate = false;
  }
}

  // To Verify Missing Fields
  handleVerify() {
    this.requiredFields = {
      alienRegNo: false,
      benForeignAddress: {
        addressLine1: true,
        city: true,
        country: true,
        postCode: true,
        state: true,
      },
      benMailingAddress: {
        addressLine1: true,
        city: true,
        country: true,
        postCode: true,
        state: true,
      },
      birthCity: true,
      birthCountry: true,
      birthState: true,
      citizenShip: true,
      countryCode: true,
      dob: true,
      emailId: true,
      firstName: true,
      gender: true,
      immigrationDetails: {
        placeOfLastArrival: false,
        modeOfTravel: false,
        city: false, // there is not field in UI
        state: false, // there is not field in UI
        arrivalDate: false,
        admittedAs: false,
        classOfAdmission: false,
        i94ExpiryDate: false,
        i94Number: false,
        arrivalCity: false,
        arrivalCountryCode: false,
        arrivalCountryName: false,
        arrivalStateProvinceCode: false,
        arrivalStateProvinceName: false
      },
      lastName: true,
      mobileNo: true,
    };
    if (!this.iterateRequiredFileds(this.requiredFields, null)) {
      if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
        this.updateStepStatus('INPROGRESS');
      }
      this.toastr.success('Fields validation is successful', 'Success');
    } else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Check the missing fields');
    }
  }

  iterateRequiredFileds(obj, parentKey) {
    let missingValueFalg = false;
    for (const key in obj) {
      if (parentKey) {
        // for object inside Obj
        if (obj[key] && (this.beneficiaryPersonalDetails[parentKey] === null ||
          this.beneficiaryPersonalDetails[parentKey][key] === null ||
          this.beneficiaryPersonalDetails[parentKey][key] == undefined ||
          this.beneficiaryPersonalDetails[parentKey][key] == '')) {
          missingValueFalg = true;
        }
      }
      else if (key === 'immigrationDetails' || key === 'benForeignAddress' || key === 'benMailingAddress') {
        this.iterateRequiredFileds(this.requiredFields[key], key);
      }
      else if (this.beneficiaryPersonalDetails[key] && (typeof this.beneficiaryPersonalDetails[key] === 'object')) {
        this.iterateRequiredFileds(this.requiredFields[key], key);
      }
      else {
        // for dirct child within Obj
        if (obj[key] && (this.beneficiaryPersonalDetails[key] === null ||
          this.beneficiaryPersonalDetails[key] == undefined ||
          this.beneficiaryPersonalDetails[key] == '')) {
          missingValueFalg = true;
        }
      }
    }
    return missingValueFalg;
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({
      payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
      subTaskId: this.stepDetails.taskId,
      actionCode: this.stepDetails.stepActionList[0].layoutCode
    }));
  }

  // Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW' ||
    //   this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
    //   this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT';
  }

  handleClose() {
    this.dynamicDialogRef.close();
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

  updateNoteAvailability(e) {
    this.stepDetails.notesAvailable = e?.notesAvailable || false;
    this.stepDetails.notes.noteText = e.noteText || '';
  }

  updateProfile() {
    let a = window.location.href
    if (a.toString().includes('/beneficiary-profile')) {
      window.location.href = window.location.origin + '/beneficiary-profile/profile?prop=BENE&section=1';
    } else {
      let beneficiaryId = sessionStorage.getItem('beneficiaryId');
      sessionStorage.setItem('listBeneficiaryId', beneficiaryId);
      let url;
      if (this.userType === RolesRouteMap.ATTORNEY) {
        url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`];
      } else {
        url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile`];
      }
      sessionStorage.setItem('bene-update-profile', 'true');
      sessionStorage.removeItem('bene-update-experience');
      this.router.navigate(url, { state: { redirectUrl: this.router.url, redirectPage: 'Back to Petition Builder' } });
    }
  }

  editDetails(){    
    this.isEditMode = true;    
   // sessionStorage.setItem('primaryData',JSON.stringify(this.primaryData));
  }

  receiveData(data: string) {
    this.isEditMode = false; 
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  onClosePersonalEdit(){
    this.isEditMode = false;
    //super.getBenDataProfile();
  }

}
